<template>
  <div class="attachment-block clearfix" v-if="singleLoanMemberDetail.member_profile">
    <img v-if="singleLoanMemberDetail.member_profile.photo" class="attachment-img" :src="this.$store.state.imageBaseUrl + + singleLoanMemberDetail.id + '/photo/' + singleLoanMemberDetail.member_profile.photo" alt="User Image">
    <img v-else class="attachment-img" src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt="Attachment Image">
    <div class="attachment-pushed">
        <h4 class="attachment-heading" v-if="singleLoanMemberDetail.name"><a href="http://www.lipsum.com/">{{ singleLoanMemberDetail.name.toUpperCase() }} ( {{ singleLoanMemberDetail.code }} )</a></h4>
      <div class="attachment-text">
        Mobile - {{ singleLoanMemberDetail.mobile }}<span v-if="singleLoanMemberDetail.member_profile.aadharNo">, AadharNo - {{ singleLoanMemberDetail.member_profile.aadharNo }}</span>
        <span v-if="singleLoanMemberDetail.member_profile.panNo">, PancardNo - {{ singleLoanMemberDetail.member_profile.panNo }}</span>
        <span v-if="singleLoanMemberDetail.member_profile.voterIdCardNo">, VoterIDCardNo - {{ singleLoanMemberDetail.member_profile.voterIdCardNo }}</span> <br>
        Address - {{ singleLoanMemberDetail.member_profile.address }}, {{ singleLoanMemberDetail.member_profile.area }}, {{ singleLoanMemberDetail.member_profile.city }}, Pincode - {{ singleLoanMemberDetail.member_profile.pin }} <br> 
        <span v-if="singleLoanMemberDetail.member_profile.businessName">, Business Name - {{ singleLoanMemberDetail.member_profile.businessName }}</span>
        <span v-if="singleLoanMemberDetail.member_profile.businessAddress">, Business Address - {{ singleLoanMemberDetail.member_profile.businessAddress }} <br></span>
        <span v-if="singleLoanMemberDetail.member_profile.guarantorName"> Co-Applicant Name - {{ singleLoanMemberDetail.member_profile.guarantorName }}</span>
        <span v-if="singleLoanMemberDetail.member_profile.guarantorAddress">, Co-Applicant Address - {{ singleLoanMemberDetail.member_profile.guarantorAddress }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'customerdetailscomponent',
  props: {
    singleLoanBranchDetail: {},
    singleLoanMemberDetail: {}
  }
}
</script>



// WEBPACK FOOTER //
// CustomerDetailsComponent.vue?c1671f96